module.exports = __webpack_public_path__ + "img/img14@2x.53c36aa1.png";